<template>
  <div class="product-table-container">
    <b-container fluid class="table-bar border-bottom py-2">
      <b-row class="table-options">
        <b-col>
          <b-button variant="light" class="mr-2 nm-sm" size="sm"
            >Prepare Quote</b-button
          >
          <b-button variant="light" class="mx-2 nm-sm" size="sm"
            >Print tags</b-button
          >
          <p class="d-inline-block text-small text-little mb-0 mx-2">
            <span>{{ tableData.length }} Products</span>
            <span v-if="selectedCount"
              >&nbsp;({{ selectedCount }} selected)</span
            >
          </p>
        </b-col>
        <b-col class="text-right">
          <b-button
            @click="tableSize = 'small'"
            variant="light"
            class="mr-1 nm-sm"
            size="sm"
            ><i class="fas fa-table fa-sm"></i
          ></b-button>
          <b-button
            @click="tableSize = 'medium'"
            variant="light"
            class="mr-1 nm-sm"
            size="sm"
            ><i class="fas fa-table"></i
          ></b-button>
          <b-button
            @click="tableSize = 'large'"
            variant="light"
            class="mr-2 nm-sm"
            size="sm"
            ><i class="fas fa-table fa-lg"></i
          ></b-button>
          <b-button variant="light" class="mx-2 nm-sm" size="sm"
            ><i class="fas fa-file-export"></i> Export</b-button
          >
          <b-button variant="light" class="mx-2 nm-sm" size="sm">$$</b-button>
          <b-button class="mx-2 nm-sm" variant="info" size="sm"
            ><i class="fas fa-times-circle"></i> Clear Search</b-button
          >
        </b-col>
      </b-row>
    </b-container>
    <b-table
      id="product-table"
      responsive
      striped
      bordered
      sticky-header
      :class="
        tableSize === 'small'
          ? 'small-table'
          : tableSize === 'medium'
          ? 'medium-table'
          : ''
      "
      :fields="tableColumns"
      :items="tableData"
      :busy="tableLoading"
    >
      <template v-slot:thead-top="">
        <b-tr class="rd-connect">
          <b-th colspan="7"><span class="sr-only">RetailDeck</span></b-th>
          <b-th variant="info" class="text-center" colspan="3"
            >RetailDeck Connect</b-th
          >
        </b-tr>
      </template>
      <template v-slot:cell(selected)="data">
        <div>
          <b-form-checkbox
            :size="tableSize !== 'small' ? 'lg' : ''"
            v-model="selectedInTable[`${data.item.brand}:${data.item.pn}`]"
          ></b-form-checkbox>
        </div>
      </template>
      <template v-slot:cell(thumbnail)="data">
        <img :src="`${data.value}`" :alt="data.item.pn" />
      </template>
      <template v-slot:cell(description)="data">
        <div class="table-description" v-html="data.value"></div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'ProductTable',
  data() {
    return {
      tableColumns: [
        { key: 'selected', label: '' },
        { key: 'pn', label: 'PN', stickyColumn: true },
        { key: 'thumbnail', label: 'Image' },
        'brand',
        'description',
        '$$',
        'memo',
        'available',
        'rdc',
        'MSRP',
        { key: 'add', label: '+' }
      ],
      tableData: [],
      tableLoading: true,
      tableSize: 'medium',
      selectedInTable: {}
    };
  },
  methods: {
    getTableData() {
      // this.$http
      //   .get("/getTableData", { params: {} })
      //   .then(res => {
      //     this.tableData = res.data;
      //   })
      //   .catch(err => {
      //     console.error(err);
      //   });
      this.tableData = [
        {
          pn: 'ABB1921BRA',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRB',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRC',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRD',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRE',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRF',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRG',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRH',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRI',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRJ',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRK',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRL',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRM',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRN',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRO',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRP',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRQ',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRR',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        },
        {
          pn: 'ABB1921BRS',
          thumbnail:
            'https://www.specsserver.com/RTDK/BMLXYZEAFNFBKBZYJWGAQINISWLPDHUNAPEL.JPG?width=50&height=50',
          brand: 'AMN',
          description:
            '29-inch Wide Bottom-Freezer Refrigerator with Garden Fresh Crisper Bins -- 18 cu. ft. Capacity - Black',
          $$: '',
          memo: '',
          available: 3,
          rdc: '',
          MSRP: '$959'
        }
      ];
      this.tableLoading = false;
    }
  },
  computed: {
    selectedCount() {
      let count = 0;
      for (var item in this.selectedInTable) {
        if (this.selectedInTable[item]) count++;
      }
      return count;
    }
  },
  mounted() {
    this.getTableData();
  }
};
</script>

<style lang="scss">
.table-bar {
  background-color: #f9feff;
}
#product-table {
  background-image: url(../assets/paper_fibers.png);
  &.table td {
    text-align: left;
    vertical-align: middle;

    &[aria-colindex='1'] {
      width: 30px;
    }
  }
  th {
    padding: 0.2rem 0.5rem;
  }
  .table-description {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    min-width: 204px;
  }
  img {
    width: 50px;
    height: 50px;
  }
}
.medium-table #product-table {
  font-size: 14px;
  td,
  th {
    padding: 0.2rem 0.4rem;
  }
  img {
    width: 35px;
    height: 35px;
  }
}
.small-table #product-table {
  font-size: 11px;
  td,
  th {
    padding: 0 0.2rem;
  }
  td[aria-colindex='1'] {
    width: 20px;
  }
  img {
    width: 20px;
    height: 20px;
  }
  .custom-control {
    padding-left: 2rem;
  }
}
.b-table-sticky-header {
  max-height: calc(100vh - 134px);
}
.b-table-sticky-header > .table.b-table > thead > tr > th {
  border-top: 0;
}

.b-table-sticky-header > .table.b-table > thead > tr:not(.rd-connect) th {
  top: 17px;
}

.fa-table.fa-sm {
  font-size: 0.775em;
}
.custom-checkbox.b-custom-control-lg,
.input-group-lg .custom-checkbox {
  padding-left: 2.3rem;
}
</style>
